// Used U/Assesment
export const PILOT_TAGS = {
    BETTERSPACE_2: 'Betterspace 2',
    STUDENTS: 'Students',
    ACCENTURE: 'Accenture',
    LINKLATERS: 'Linklaters',
}

export const tooltips = {
    lifeSatisfaction: 'Overall, how satisfied are you with your life nowadays?',
    positiveEmployer: {
        default: 'Do you feel your employment is positively impacting your wellbeing?',
        [PILOT_TAGS.STUDENTS]:
            'Do you feel the course you are studying positively impacts your wellbeing?',
        [PILOT_TAGS.ACCENTURE]:
            'Do you feel there’s a senior person at work who genuinely cares about your wellbeing?',
        [PILOT_TAGS.LINKLATERS]:
            'Do you feel your experience at Linklaters is positively impacting your wellbeing?',
    },
    priceApprox:
        'Displayed EUR prices are approximate and will fluctuate due to live conversion rates.\n\nPayments will be charged in GBP.',
}
